import {
  Accordion,
  AccordionHeader,
  AccordionItem,
  AccordionPanel,
  Divider,
  Label,
} from "@fluentui/react-components";
import { CodeRegular } from "@fluentui/react-icons";
import React from "react";

import {
  DragAndDropAcceptFileType,
  DragAndDropFields,
  DragAndDropUploadData,
  dragAndDropAcceptFiles,
} from "@/components/DragAndDropFields";
import { RenderUploadedRow } from "@/components/DragAndDropFields/helper";
import { translation } from "@/i18n";
import { nsUpload } from "@/i18n/locales/upload";
import styles from "./index.module.css";

const useTranslation = translation.use(nsUpload);

const indexJsonSample = `{
  "id": "example",        // → アドオンID（変更不可）
  "displayName": "検証用addon", // → アドオン名
  "version": "1.0.0"      // → バージョン名
}`;

/**
 * @description アドオンファイル入力欄
 * (必須ラベル + ZIPドロップゾーン + index.json の注記・説明アコーディオン)
 */
export const FrontendAddonFileField: React.FC<{
  uploadedFileList: DragAndDropUploadData[];
  setUploadedFileList: React.Dispatch<
    React.SetStateAction<DragAndDropUploadData[]>
  >;
  existingType: DragAndDropAcceptFileType | undefined;
  setExistingType: React.Dispatch<
    React.SetStateAction<DragAndDropAcceptFileType | undefined>
  >;
  isDisableForm: boolean;
}> = ({
  uploadedFileList,
  setUploadedFileList,
  existingType,
  setExistingType,
  isDisableForm,
}) => {
  const { t } = useTranslation();
  return (
    <div className={styles.fileField}>
      <Label required>アドオンファイル</Label>
      <DragAndDropFields
        accept={dragAndDropAcceptFiles["zip"]}
        uploadedFileList={uploadedFileList}
        setUploadedFileList={setUploadedFileList}
        existingType={existingType}
        setExistingType={setExistingType}
        fileTypeConfigs={[{ type: "zip", limit: 1 }]}
        isDisableDragAndDrop={isDisableForm}
        extElement={
          uploadedFileList.length > 0 ? (
            <>
              <div className={styles.subtitle}>{t.upload.dataName()}</div>
              {uploadedFileList.map(
                ({ file, id, isDisableDelete: isDisableDeleteRow }) => (
                  <RenderUploadedRow
                    key={id}
                    file={file}
                    id={id}
                    isDisableDeleteButton={isDisableForm || isDisableDeleteRow}
                    onDelete={() => {
                      setUploadedFileList((state) =>
                        state.filter((v) => v.id !== id)
                      );
                    }}
                  />
                )
              )}
            </>
          ) : null
        }
      />
      <div className={styles.note}>
        アドオン名・バージョン名は、ZIP内の index.json（displayName,
        version）から自動設定されます。
        <br />
        id
        は初回登録後に変更できません。他のアドオンと重複するとエラーになります。
      </div>
      <Divider className={styles.divider} />
      <Accordion collapsible>
        <AccordionItem value="indexJson">
          <AccordionHeader
            className={styles.accordionHeader}
            expandIconPosition="end"
            icon={<CodeRegular />}
          >
            index.jsonで設定される項目について
          </AccordionHeader>
          <AccordionPanel>
            <div className={styles.accordionPanelBody}>
              アドオンのZIPファイルに含まれる index.json
              の内容から、以下の項目が自動設定されます。
              <pre className={styles.indexJsonSample}>{indexJsonSample}</pre>
            </div>
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </div>
  );
};
